import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';

export default grapesjs.plugins.add('gjs-role-mapping-dropdown', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'role-mapping-dropdown',
    blocks: ['role-mapping-dropdown'],
    defaultStyle: true,
    label: 'Tenant Role Mapping (D)',
    labels: {
      container: 'Tenant Role Mapping',
      label: 'Tenant Role Mapping (D)',
    },
    category: 'CMS',
    type: 'role-mapping-dropdown',
    types: {
      type: 'role-mapping-dropdown',
      select: 'role-mapping-dropdown-select',
    },
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
  loadTraits(editor, options);
});
